import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.initials.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([[_ctx.sizeClasses, _ctx.variantClasses], "rounded-full grid content-center justify-center text-white"])
      }, _toDisplayString(_ctx.initials), 3))
    : _createCommentVNode("", true)
}